import React, { useEffect, useState } from "react";

// Classes were not applying on the hydration when URL context was giving values
// https://github.com/GlamCorner/catalogue/issues/143
// https://github.com/facebook/react/issues/13260
export const SSRClassFix: React.FC = ({ children }) => {
  const [rendered, setRendered] = useState(false);

  // useEffect only runs on client when component mounts
  // This will force a re-render of the child component
  useEffect(() => {
    setRendered(true);
  }, []);

  // Component will initially render with ssr-fix class from server side
  // Once mounted, wrapper will be removed
  return rendered ? <>{children}</> : <div className="ssr-fix">{children}</div>;
};
